import { gql, type TypedDocumentNode } from "@apollo/client";
import type { PaginationVariables } from "@/components/Pagination/Pagination";
import type { CommissionProgramNode } from "./types";

export interface CommissionProgramsQueryResponse {
  commissionPrograms: {
    nodes: CommissionProgramNode[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
  };
}

export type CommissionProgramsQueryVariables = PaginationVariables;

export const COMMISSION_PROGRAMS_QUERY: TypedDocumentNode<
  CommissionProgramsQueryResponse,
  CommissionProgramsQueryVariables
> = gql`
  query CommissionPrograms($first: Int, $after: String, $last: Int, $before: String) {
    commissionPrograms(first: $first, after: $after, last: $last, before: $before) {
      nodes {
        id
        name
        slug
        status
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
